let _calendarEntry: Promise<typeof import('@/components/base/RDatePicker/ChineseCalendar/CalendarEntry')> | null = null

export const loadCalendarEntry = async () => {
  if (!_calendarEntry) {
    _calendarEntry = import('@/components/base/RDatePicker/ChineseCalendar/CalendarEntry').then((module) => {
      if (!module?.toDateWrapper) throw new Error('CalendarEntry模块不完整')
      return module
    })
  }
  return _calendarEntry
}
